export default __webpack_public_path__ + "static/media/keras-text.f3757578.svg";